import { render, staticRenderFns } from "./TheOverviewPanel.vue?vue&type=template&id=528b37be&"
import script from "./TheOverviewPanel.vue?vue&type=script&lang=js&"
export * from "./TheOverviewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports